var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState, useMemo } from 'react';
import { Button, Container, Heading, PageHeading } from '../../../components/shared';
import '../question-sets/question-sets.scss';
import { services } from '../../../shared';
import { CaseNavigation } from '../case-navigation/case-navigation';
import { CustomerDocumentsTable } from './customer-documents/customer-documents';
import { SectionMenu } from '../../../components/sections/question-sets/section-menu/section-menu';
import { UploadDocument } from '../upload-document/upload-document';
import { useHistory } from 'react-router';
import { LoaderWrapper } from '../../../shared/utils/loader/loader-wrapper';
import { useLoader } from '../../../shared/utils';
import { DefaultLoadingComponent } from '../../../shared/utils/loader/default-loading-component';
export var Documents = function (_a) {
    var _b, _c, _d, _e, _f;
    var _pages = _a.pages, steps = _a.steps, rootPath = _a.rootPath, location = _a.location, workflowName = _a.workflowName, caseId = _a.caseId, formId = _a.formId, loanPurposeId = _a.loanPurposeId;
    var _g = useState(false), menuVisible = _g[0], toggleMenuVisibility = _g[1];
    var _h = useState(), caseDetails = _h[0], setCaseDetails = _h[1];
    var _j = useState(), modalVisible = _j[0], setModalVisible = _j[1];
    var _k = useState(0), customerIdForUpload = _k[0], setCustomerIdForUpload = _k[1];
    var _l = useState(0), documentGridToRefresh = _l[0], setDocumentGridToRefresh = _l[1];
    var _m = useState([]), documentCounts = _m[0], setDocumentCounts = _m[1];
    var _o = useState(true), mandatoryDocuments = _o[0], setMandatoryDocuments = _o[1];
    var _p = useState(false), allowProceed = _p[0], setAllowProceed = _p[1];
    var _q = useState(), nextPage = _q[0], setNextPage = _q[1];
    var history = useHistory();
    var _r = useState(0), refreshedCounter = _r[0], setRefreshedCounter = _r[1];
    var pages = useMemo(function () { var _a, _b; return (_pages.length > 0 ? _pages : (_b = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.pages) !== null && _b !== void 0 ? _b : []); }, [_pages]);
    var fetchDocuments = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var documents, applicant, docCounts, sum;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    caseDocumentsSetIsLoading(true);
                    return [4 /*yield*/, services.getCustomerDocuments(id)];
                case 1:
                    documents = (_a.sent()).data;
                    applicant = caseDetails.applicants.filter(function (a) { return a.customerId === id; })[0];
                    docCounts = documentCounts;
                    docCounts.splice(caseDetails.applicants.indexOf(applicant), 1, documents.length);
                    setDocumentCounts(docCounts);
                    sum = docCounts.reduce(function (sum, a) { return sum + a; });
                    setAllowProceed(sum > 0);
                    return [4 /*yield*/, updateNextButtonState(id, documents)];
                case 2:
                    _a.sent();
                    caseDocumentsSetIsLoading(false);
                    return [2 /*return*/, documents];
            }
        });
    }); };
    // this function is used for checking, atlease one document should be uploaded for Main Applicant
    // then only submit application button enabled.
    var updateNextButtonState = function (id, documents) { return __awaiter(void 0, void 0, void 0, function () {
        var mainApplicant, mainApplicantDocuments, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    mainApplicant = caseDetails.applicants.find(function (applicant) { return applicant.isMainApplicant; });
                    if (!mainApplicant || !mandatoryDocuments || caseDetails.applicants.length < 2) {
                        return [2 /*return*/];
                    }
                    if (!(mainApplicant.customerId === id)) return [3 /*break*/, 1];
                    _a = documents;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, services.getCustomerDocuments(mainApplicant.customerId)];
                case 2:
                    _a = (_b.sent()).data;
                    _b.label = 3;
                case 3:
                    mainApplicantDocuments = _a;
                    setAllowProceed(mainApplicantDocuments.length > 0);
                    return [2 /*return*/];
            }
        });
    }); };
    var showModal = function (e) {
        setCustomerIdForUpload(Number(e.currentTarget.getAttribute('data-value')));
        setModalVisible(true);
    };
    var reloadDocumentGrid = function (customerId) {
        setDocumentGridToRefresh(customerId);
    };
    var hideModal = function () {
        setModalVisible(false);
    };
    var fetchCaseDetails = function (id, loanPurposeId) { return __awaiter(void 0, void 0, void 0, function () {
        var c, _a, m;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!((_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.case) !== null && _c !== void 0)) return [3 /*break*/, 1];
                    _a = _c;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, services.getCase(id)];
                case 2:
                    _a = (_d.sent()).data;
                    _d.label = 3;
                case 3:
                    c = _a;
                    location.state = {
                        applicants: c.applicants,
                        case: c,
                        loanPurposeId: loanPurposeId,
                    };
                    setDocumentCounts(c.applicants.map(function () { return 0; }));
                    return [4 /*yield*/, services.getMandatoryDocuments()];
                case 4:
                    m = (_d.sent()).data;
                    setMandatoryDocuments(m.value.toLowerCase() === 'on');
                    setCaseDetails(c);
                    return [2 /*return*/];
            }
        });
    }); };
    var deleteDocument = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!window.confirm('Are you sure you wish to delete this document?')) return [3 /*break*/, 2];
                    id = e.currentTarget.getAttribute('data-value');
                    return [4 /*yield*/, services.deleteCustomerDocument(Number(id))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var saveSectionEvent = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    caseDocumentsSetIsLoading(true);
                    return [4 /*yield*/, services.UpdateDocumentPageViewed(location.state.case.id, formId)];
                case 1:
                    _a.sent();
                    history.push(nextPage.path, __assign(__assign({}, location.state), { pages: pages }));
                    caseDocumentsSetIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchCaseDetails(caseId, loanPurposeId);
    }, [caseId, loanPurposeId]);
    useEffect(function () {
        setRefreshedCounter(refreshedCounter + 1);
    }, [documentGridToRefresh, customerIdForUpload]);
    var caseDocumentsSetIsLoading = useLoader({ identifier: 'caseDocuments' }).caseDocumentsSetIsLoading;
    var caseSectionMenuIsLoading = useLoader({ identifier: 'caseSectionMenu' }).caseSectionMenuIsLoading;
    return (React.createElement(React.Fragment, null,
        React.createElement(UploadDocument, { customerId: customerIdForUpload, reloadDocumentGrid: function (customerId) {
                setRefreshedCounter(refreshedCounter + 1);
                reloadDocumentGrid(customerId);
            }, show: modalVisible, handleClose: hideModal, isEmailSend: false }),
        React.createElement("div", { className: "l-question-sets" },
            React.createElement("div", { className: "l-question-sets__toggle-menu" },
                React.createElement(Button, { type: "button", variant: "navy", icon: "chevronRight", iconPosition: "right", onClick: function () { return toggleMenuVisibility(!menuVisible); } }, "Open Steps")),
            React.createElement("div", { className: "l-question-sets__content" },
                React.createElement("div", { className: "l-question-sets__menu ".concat(menuVisible && 'isActive') },
                    caseSectionMenuIsLoading && (React.createElement("div", null,
                        React.createElement("header", { className: "c-section-menu__header" },
                            React.createElement(DefaultLoadingComponent, { height: 10, width: '15.75rem' })))),
                    React.createElement(LoaderWrapper, { height: 10, width: '15.75rem', count: 10, loaderComponentProps: { style: { margin: '1rem 0.75rem 1.25em 0.75rem' } }, identifier: "caseSectionMenu" },
                        React.createElement(SectionMenu, { pages: pages, rootPath: rootPath, location: location, workflowName: workflowName, closeMenu: toggleMenuVisibility }))),
                React.createElement("div", { className: "l-question-sets-anchor-bg" }),
                React.createElement("div", { className: "l-question-sets__questions" },
                    React.createElement("div", { className: "l-question-sets__header" },
                        React.createElement(PageHeading, { headingLevel: 2, title: 'Documents', icon: workflowName === null || workflowName === void 0 ? void 0 : workflowName.toLowerCase(), mb: 6 })),
                    React.createElement(Container, { ctabar: true },
                        React.createElement("div", { className: "c-question-set" },
                            React.createElement(Heading, { level: "h3", title: 'Documents Required', mb: 4 }),
                            React.createElement("span", { className: "u-fs-2" }, "Please upload supporting documentation:"),
                            ((_b = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                                ((_d = (_c = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _c === void 0 ? void 0 : _c.filter(function (a) { var _a; return (_a = a.isMainApplicant) !== null && _a !== void 0 ? _a : false; })) === null || _d === void 0 ? void 0 : _d.length) > 0 && (React.createElement(CustomerDocumentsTable, { applicant: (_e = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _e === void 0 ? void 0 : _e.filter(function (a) { var _a; return (_a = a.isMainApplicant) !== null && _a !== void 0 ? _a : false; })[0], deleteDocumentFunction: deleteDocument, fetchData: fetchDocuments, showModal: showModal, modalVisible: modalVisible, refresh: refreshedCounter })), (_f = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _f === void 0 ? void 0 :
                            _f.filter(function (a) { return !a.isMainApplicant; }).map(function (doc, index) {
                                var _a;
                                return (React.createElement("div", { key: doc.customerId },
                                    React.createElement("span", null),
                                    React.createElement(CustomerDocumentsTable, { key: doc.customerId, applicant: (_a = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _a === void 0 ? void 0 : _a.filter(function (a) { return a.customerId === doc.customerId; })[0], index: index + 1, deleteDocumentFunction: deleteDocument, fetchData: fetchDocuments, showModal: showModal, modalVisible: modalVisible, refresh: refreshedCounter })));
                            }),
                            React.createElement(CaseNavigation, { pages: pages, workflowSteps: steps, location: location, setTargetPage: setNextPage, onNextClick: saveSectionEvent, nextDisabled: (mandatoryDocuments && allowProceed) || !mandatoryDocuments ? false : true }))))))));
};
